import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { PageMeta, PageHero, CtaBand, Icon } from '../components/ui';

const STEPS = [
  { icon: 'car', title: 'Choose a package', text: 'Pick the Basic Wash (exterior, AED 30), Deluxe Wash (inside and out, AED 45) or Premium Detail (AED 65). Add extras like odour removal if you need them.' },
  { icon: 'pin', title: 'Tell us where the car is', text: 'Share the emirate, community and exact spot: villa driveway, building name with parking level and bay, or office car park. Mention any gate or building access steps.' },
  { icon: 'calendar', title: 'Pick a preferred day and time', text: 'Choose a day and a morning, afternoon or evening window. In summer, early or late slots are more comfortable and keep products from drying too fast on hot paint.' },
  { icon: 'chat', title: 'We confirm your booking', text: 'Our team confirms the time slot and final price in the app or on WhatsApp. Your booking is only confirmed once you receive this reply.' },
  { icon: 'sparkle', title: 'Your car is washed where it is parked', text: 'The team arrives at the agreed time and carries out your package at your location.' }
];

const HowItWorks = () => {
  const { BUSINESS } = useSite();
  return (
  <>
    <PageMeta
      title="How Our Mobile Car Wash Works | Quick Way"
      description="How to book a doorstep car wash in Abu Dhabi or Dubai: choose a package, share your location and time, and we confirm your slot."
      path="/how-it-works"
      crumbs={[{ name: 'How it works', path: '/how-it-works' }]}
    />
    <PageHero eyebrow="How it works" title="How a Quick Way doorstep car wash works">
      <p>Booking takes a few minutes, and the wash happens wherever your car is parked in Abu Dhabi or Dubai.</p>
    </PageHero>
    <section className="section">
      <div className="container container--narrow">
        <ol className="timeline">
          {STEPS.map((s, i) => (
            <li key={s.title}>
              <span className="timeline__dot"><Icon name={s.icon} size={20} /></span>
              <div>
                <h2><span className="muted">Step {i + 1}.</span> {s.title}</h2>
                <p>{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
        <div className="note-box">
          <Icon name="building" size={20} />
          <p>Washing in a tower car park? Some buildings restrict car washing in their basements. Please check with your building management before booking.</p>
        </div>
        <h2 className="h-section h-section--spaced">Ways to order</h2>
        <div className="grid grid-3">
          <a href={BUSINESS.playStore} target="_blank" rel="noopener noreferrer" className="feature feature--link"><span className="icon-tile"><Icon name="play" /></span><h3>Quick Way app</h3><p>The fastest way — drop a pin on the map, choose a package and manage your washes.</p></a>
          <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noopener noreferrer" className="feature feature--link"><span className="icon-tile"><Icon name="chat" /></span><h3>WhatsApp</h3><p>Message {BUSINESS.phoneDisplay} with your car, location and time.</p></a>
          <Link to="/book" className="feature feature--link"><span className="icon-tile"><Icon name="calendar" /></span><h3>Booking form</h3><p>Fill in your details here and send them to us on WhatsApp.</p></Link>
        </div>
      </div>
    </section>
    <CtaBand source="how_it_works" />
  </>
);
};

export default HowItWorks;
